




















import { Vue, Component } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class FormLayout extends Vue {

    submit() {
        this.$emit('submit');
    }
}
